import gql from 'graphql-tag';

export const DOMAIN_FRAGMENT = gql`
  fragment domain on Domain {
    id
    url
    orgName
    industry
    email
    address
    authorizedDomain
    slackWorkspace {
      name
      slackId
    }
    picture
    isBillingCurrent
  }
`;
